import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch strike workflow configuration for a community
 */
export const GET_STRIKE_CONFIGURATION = gql`
  query GetStrikeWorkflowConfiguration($communityId: ID!) {
    community(id: $communityId) {
      id
      workflowConfigurations {
        type
        rollingWindowDays
        labelStrikeMappings {
          labelId
          severity
          points
        }
      }
    }
  }
`;
